import { render, staticRenderFns } from "./VWaitDefaultLoader.vue?vue&type=template&id=506c207a"
import script from "./VWaitDefaultLoader.vue?vue&type=script&lang=js"
export * from "./VWaitDefaultLoader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports